import React from "react";
import DrEditor from "./Editor";

const CourseDesc = (props) => {
  const defaultText =
    props.locale == "en" ? "English Description" : "Arabic Description";
  const key = "course-desc-" + props.locale;
  const changeOpts = {
    locale: props.locale,
    type: "course_description",
  };

  return (
    <div
      id={key}
      className="table table-bordered inner-buffer sm-font"
      style={{ minHeight: "8rem" }}
      onClick={(e) => props.focus(key, e)}
    >
      <DrEditor
        updateType={props.type}
        defaultText={defaultText}
        text={props.text || ""}
        parentKey={key}
        handleChange={props.handleChange}
        changeOpts={changeOpts}
        focusKey={props.focusKey}
        dataReady={props.dataReady}
      />
    </div>
  );
};

export default CourseDesc;
